import * as yup from "yup";
import i18next from "config/i18next";
import { AnyObject } from "final-form";
import { SlotsConstants } from "constants/slots";

const requiredMessage = i18next.t("validations:required");

const requiredString = yup.string().required(requiredMessage);

const validatePickerId = (
  errorCode: number | null,
  context: yup.TestContext<AnyObject>
) => {
  const { createError } = context;
  const path = "id";
  let message = errorCode ? SlotsConstants.getErrorMessage(errorCode) : null;

  if (message) {
    return createError({
      message,
      path,
    });
  }

  return true;
};

export const newPickerSchema = (errorCode: number | null) =>
  yup.object({
    id: yup
      .string()
      .test("pickerIdValidation", (value, context) =>
        validatePickerId(errorCode, context)
      ),
    name: requiredString,
    phone: requiredString,
  });
